import { ModalHeader, Text } from '@livechat/design-system-react-components'

import { useOneClickPaymentContext } from '@/context/OneClickPayment'
import { ChargeType } from '@/constants/payment'

export const PurchaseHeader = () => {
  const { paymentIntent } = useOneClickPaymentContext()
  const isRecurrentCharge =
    paymentIntent?.metadata.type === ChargeType.RecurrentCharge

  return (
    <ModalHeader title="Confirm purchase">
      <Text size="sm" data-test="ocp-modal-subheader">
        {isRecurrentCharge
          ? 'The application subscription will start after the free trial period.'
          : 'The application subscription will start immediately.'}
      </Text>
    </ModalHeader>
  )
}

export default PurchaseHeader
